// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountingExports__FormController from "./accounting_exports/form_controller"
application.register("accounting-exports--form", AccountingExports__FormController)

import AccountingPattern__AccountingPatternController from "./accounting_pattern/accounting_pattern_controller"
application.register("accounting-pattern--accounting-pattern", AccountingPattern__AccountingPatternController)

import Admin__Admins__FormController from "./admin/admins/form_controller"
application.register("admin--admins--form", Admin__Admins__FormController)

import Admin__Admins__TableController from "./admin/admins/table_controller"
application.register("admin--admins--table", Admin__Admins__TableController)

import Admin__Announcements__FormController from "./admin/announcements/form_controller"
application.register("admin--announcements--form", Admin__Announcements__FormController)

import Admin__Announcements__TableController from "./admin/announcements/table_controller"
application.register("admin--announcements--table", Admin__Announcements__TableController)

import Admin__Companies__FormController from "./admin/companies/form_controller"
application.register("admin--companies--form", Admin__Companies__FormController)

import Admin__Companies__TableController from "./admin/companies/table_controller"
application.register("admin--companies--table", Admin__Companies__TableController)

import Admin__Users__FormController from "./admin/users/form_controller"
application.register("admin--users--form", Admin__Users__FormController)

import Admin__Users__SearchController from "./admin/users/search_controller"
application.register("admin--users--search", Admin__Users__SearchController)

import Admin__Users__TableController from "./admin/users/table_controller"
application.register("admin--users--table", Admin__Users__TableController)

import Attandances__ClockController from "./attandances/clock_controller"
application.register("attandances--clock", Attandances__ClockController)

import Attandances__ConfirmController from "./attandances/confirm_controller"
application.register("attandances--confirm", Attandances__ConfirmController)

import Attandances__CsvImportController from "./attandances/csv_import_controller"
application.register("attandances--csv-import", Attandances__CsvImportController)

import Attandances__FormController from "./attandances/form_controller"
application.register("attandances--form", Attandances__FormController)

import Attandances__GroupController from "./attandances/group_controller"
application.register("attandances--group", Attandances__GroupController)

import Attandances__PhotoController from "./attandances/photo_controller"
application.register("attandances--photo", Attandances__PhotoController)

import Attandances__PhotoNavController from "./attandances/photo_nav_controller"
application.register("attandances--photo-nav", Attandances__PhotoNavController)

import Attandances__RecordLogController from "./attandances/record_log_controller"
application.register("attandances--record-log", Attandances__RecordLogController)

import Attandances__RuleAlertController from "./attandances/rule_alert_controller"
application.register("attandances--rule-alert", Attandances__RuleAlertController)

import Attandances__ScheduleDiffController from "./attandances/schedule_diff_controller"
application.register("attandances--schedule-diff", Attandances__ScheduleDiffController)

import Attandances__ScheduleHydratorController from "./attandances/schedule_hydrator_controller"
application.register("attandances--schedule-hydrator", Attandances__ScheduleHydratorController)

import Attandances__StatusSyncController from "./attandances/status_sync_controller"
application.register("attandances--status-sync", Attandances__StatusSyncController)

import Attandances__WeatherFormController from "./attandances/weather_form_controller"
application.register("attandances--weather-form", Attandances__WeatherFormController)

import Attandances__WorkEditController from "./attandances/work_edit_controller"
application.register("attandances--work-edit", Attandances__WorkEditController)

import AttendanceReports__ReportController from "./attendance_reports/report_controller"
application.register("attendance-reports--report", AttendanceReports__ReportController)

import AttendanceRules__ListController from "./attendance_rules/list_controller"
application.register("attendance-rules--list", AttendanceRules__ListController)

import BonusHourRules__FormController from "./bonus_hour_rules/form_controller"
application.register("bonus-hour-rules--form", BonusHourRules__FormController)

import BonusHourRules__SearchController from "./bonus_hour_rules/search_controller"
application.register("bonus-hour-rules--search", BonusHourRules__SearchController)

import ChoicesController from "./choices_controller"
application.register("choices", ChoicesController)

import DataExports__DefinitionFormController from "./data_exports/definition_form_controller"
application.register("data-exports--definition-form", DataExports__DefinitionFormController)

import DataExports__DefinitionListController from "./data_exports/definition_list_controller"
application.register("data-exports--definition-list", DataExports__DefinitionListController)

import DataExports__RunController from "./data_exports/run_controller"
application.register("data-exports--run", DataExports__RunController)

import DefaultHolidays__BulkDeleteController from "./default_holidays/bulk_delete_controller"
application.register("default-holidays--bulk-delete", DefaultHolidays__BulkDeleteController)

import DefaultHolidays__GeneratorController from "./default_holidays/generator_controller"
application.register("default-holidays--generator", DefaultHolidays__GeneratorController)

import DefaultHolidays__HolidayModalController from "./default_holidays/holiday_modal_controller"
application.register("default-holidays--holiday-modal", DefaultHolidays__HolidayModalController)

import EffectiveAttendanceRules__FormController from "./effective_attendance_rules/form_controller"
application.register("effective-attendance-rules--form", EffectiveAttendanceRules__FormController)

import EffectiveAttendanceRules__ListController from "./effective_attendance_rules/list_controller"
application.register("effective-attendance-rules--list", EffectiveAttendanceRules__ListController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import OtpController from "./otp_controller"
application.register("otp", OtpController)

import OutputItems__HeaderController from "./output_items/header_controller"
application.register("output-items--header", OutputItems__HeaderController)

import OutputItems__TableController from "./output_items/table_controller"
application.register("output-items--table", OutputItems__TableController)

import OutputPatterns__FormController from "./output_patterns/form_controller"
application.register("output-patterns--form", OutputPatterns__FormController)

import OutputPatterns__TableController from "./output_patterns/table_controller"
application.register("output-patterns--table", OutputPatterns__TableController)

import Performances__AllowanceRecordsReviewController from "./performances/allowance_records_review_controller"
application.register("performances--allowance-records-review", Performances__AllowanceRecordsReviewController)

import Performances__AttendanceFieldController from "./performances/attendance_field_controller"
application.register("performances--attendance-field", Performances__AttendanceFieldController)

import Performances__ColumnToggleController from "./performances/column_toggle_controller"
application.register("performances--column-toggle", Performances__ColumnToggleController)

import Performances__FilterController from "./performances/filter_controller"
application.register("performances--filter", Performances__FilterController)

import Performances__PerformanceFieldController from "./performances/performance_field_controller"
application.register("performances--performance-field", Performances__PerformanceFieldController)

import Performances__VacationPatternController from "./performances/vacation_pattern_controller"
application.register("performances--vacation-pattern", Performances__VacationPatternController)

import Performances__VacationPatternModalController from "./performances/vacation_pattern_modal_controller"
application.register("performances--vacation-pattern-modal", Performances__VacationPatternModalController)

import Projects__BulkController from "./projects/bulk_controller"
application.register("projects--bulk", Projects__BulkController)

import Projects__ClearFilterController from "./projects/clear_filter_controller"
application.register("projects--clear-filter", Projects__ClearFilterController)

import Projects__ExpandController from "./projects/expand_controller"
application.register("projects--expand", Projects__ExpandController)

import Projects__FormController from "./projects/form_controller"
application.register("projects--form", Projects__FormController)

import Reports__ReportController from "./reports/report_controller"
application.register("reports--report", Reports__ReportController)

import ScheduleEntries__CellController from "./schedule_entries/cell_controller"
application.register("schedule-entries--cell", ScheduleEntries__CellController)

import ScheduleEntries__FilterController from "./schedule_entries/filter_controller"
application.register("schedule-entries--filter", ScheduleEntries__FilterController)

import ScheduleEntries__FormModalController from "./schedule_entries/form_modal_controller"
application.register("schedule-entries--form-modal", ScheduleEntries__FormModalController)

import ScheduleEntries__WeekCalendarController from "./schedule_entries/week_calendar_controller"
application.register("schedule-entries--week-calendar", ScheduleEntries__WeekCalendarController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SharePatterns__FormController from "./share_patterns/form_controller"
application.register("share-patterns--form", SharePatterns__FormController)

import SharePatterns__TableController from "./share_patterns/table_controller"
application.register("share-patterns--table", SharePatterns__TableController)

import SystemSettings__FormController from "./system_settings/form_controller"
application.register("system-settings--form", SystemSettings__FormController)

import SystemSettings__TableController from "./system_settings/table_controller"
application.register("system-settings--table", SystemSettings__TableController)

import Team__BulkCreationController from "./team/bulk_creation_controller"
application.register("team--bulk-creation", Team__BulkCreationController)

import TeamBulkFormController from "./team_bulk_form_controller"
application.register("team-bulk-form", TeamBulkFormController)

import TimeFieldController from "./time_field_controller"
application.register("time-field", TimeFieldController)

import ToolReports__ReportController from "./tool_reports/report_controller"
application.register("tool-reports--report", ToolReports__ReportController)

import Tools__FormController from "./tools/form_controller"
application.register("tools--form", Tools__FormController)

import Tools__TableController from "./tools/table_controller"
application.register("tools--table", Tools__TableController)

import TransferProjects__FilterController from "./transfer_projects/filter_controller"
application.register("transfer-projects--filter", TransferProjects__FilterController)

import TransferProjects__ListController from "./transfer_projects/list_controller"
application.register("transfer-projects--list", TransferProjects__ListController)

import UnsavedChangesController from "./unsaved_changes_controller"
application.register("unsaved-changes", UnsavedChangesController)

import Users__DashboardController from "./users/dashboard_controller"
application.register("users--dashboard", Users__DashboardController)

import Users__UserController from "./users/user_controller"
application.register("users--user", Users__UserController)

import VacationPatterns__FormController from "./vacation_patterns/form_controller"
application.register("vacation-patterns--form", VacationPatterns__FormController)

import VacationPatterns__TableController from "./vacation_patterns/table_controller"
application.register("vacation-patterns--table", VacationPatterns__TableController)

import Wages__FormController from "./wages/form_controller"
application.register("wages--form", Wages__FormController)

import Wages__TableController from "./wages/table_controller"
application.register("wages--table", Wages__TableController)

import WorkPerformances__FieldController from "./work_performances/field_controller"
application.register("work-performances--field", WorkPerformances__FieldController)

import WorkPerformances__FilterController from "./work_performances/filter_controller"
application.register("work-performances--filter", WorkPerformances__FilterController)

import WorkPerformances__MatrixController from "./work_performances/matrix_controller"
application.register("work-performances--matrix", WorkPerformances__MatrixController)

import WorkPerformances__ModeController from "./work_performances/mode_controller"
application.register("work-performances--mode", WorkPerformances__ModeController)

import WorkPerformances__SummaryController from "./work_performances/summary_controller"
application.register("work-performances--summary", WorkPerformances__SummaryController)

import WorkPerformances__TableController from "./work_performances/table_controller"
application.register("work-performances--table", WorkPerformances__TableController)

import WorkTypes__FormController from "./work_types/form_controller"
application.register("work-types--form", WorkTypes__FormController)

import WorkTypes__TableController from "./work_types/table_controller"
application.register("work-types--table", WorkTypes__TableController)

import Workers__WorkerController from "./workers/worker_controller"
application.register("workers--worker", Workers__WorkerController)
